import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  user: any;
  constructor(private router: Router, private authService: AuthenticationService) {
    this.user = this.authService.getDecodedUser();
   }

  ngOnInit() {
  }

}
